import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Location } from "../../../model";

@Component({
    selector: 'location-selection-dialog',
    template: require('./location-selection-dialog.component.html'),
})
export class LocationSelectionDialogComponent {

    @ViewChild('form') form: NgForm;

    locations: Location[];
    message: string;
    selectedLocationIds: string[] = [];

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<LocationSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.locations = data.locations;
        this.message = data.message;
    }

    toggleCheckbox(locationId: string, event: MatCheckboxChange): void {
        if (event.checked) {
            this.selectedLocationIds.push(locationId);
        } else {
            const idx = this.selectedLocationIds.findIndex(t => t == locationId);
            if (idx >= 0) {
                this.selectedLocationIds.splice(idx, 1);
            }
        }
    }

    save(): void {
        this.dialogRef.close(this.selectedLocationIds);
    }

}